import { AttachEmail } from '@mui/icons-material'
import ReactCountryFlag from 'react-country-flag'
import { ItemType } from '../../../util'
import ActivityMetaData from './ActivityMetaData'
import AttractionMetaData from './AttractionMetaData'
import HotelMetaData from './HotelMetaData'

const MetaDataLayout = ({ data }) => {
  if (data.item_type == ItemType.hotel) {
    let subtitle = ''
    let city = data.address.city
    let country = data.address.country
    let countryCode = data.address.country_code
    if (country && countryCode) {
      subtitle = city + ', ' + country + ' '
    }
    return (
      <HotelMetaData
        title={data.display_name}
        subtitle={subtitle}
        countryCode={countryCode}
      />
    )
  } else if (data.item_type == ItemType.activity) {
    let subtitle = ''
    let city = data.address.city
    let country = data.address.country
    let countryCode = data.address.country_code
    if (country && countryCode) {
      subtitle = city + ', ' + country + ' '
    }
    return (
      <ActivityMetaData
        name={data.display_name}
        review={data.properties.review}
        subtitle={subtitle}
        countryCode={countryCode}
      />
    )
  } else if (data.item_type == ItemType.attraction) {
    let subtitle = ''
    let country = data.address.country
    let countryCode = data.address.country_code
    if (country && countryCode) {
      // subtitle = 'Destination in ' + country + ' '
      subtitle = country + ' '
    }
    return (
      <AttractionMetaData
        title={data.display_name}
        subtitle={subtitle}
        countryCode={countryCode}
      />
    )
  }
}
export default MetaDataLayout
